// TODO revise
export enum EntityType {
    CoachingEvent = 1,
    Note,
    Interaction,
    InteractionScoring,
    Commitment,
    Goal,
    Task,
    CoachingUpdate = 10,
}
